import _ from 'lodash';

const moduleName = 'ProspectingProjectFile';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
